export const CHANGE_STATE_EVENT = '__changestate__';

export default class XFix {
  public static getInstance(): XFix {
    this.instance = this.instance || new XFix();
    return this.instance;
  }
  private static instance: XFix;

  private constructor() {
    this.handlerHistory();
  }

  private handlerHistory() {
    const createEvent = function() {
      if (window.Event) {
        return new window.Event(CHANGE_STATE_EVENT);
      }
      if (document) {
        const e = document.createEvent('HTMLEvents');
        e.initEvent(CHANGE_STATE_EVENT, !1, !0);
        return e;
      }
      return null;
    };

    const handler = function(key: string) {
      const origin = (window as any).history[key];
      return function() {
        const result = origin.apply(this, arguments);
        const event = createEvent();
        if (event) {
          window.dispatchEvent(event);
        }
        return result;
      };
    };

    window.history.pushState = handler('pushState');
    window.history.replaceState = handler('replaceState');
  }
}
